export default {
  BASE_URL: 'admin/lottery',
  api: [
    {
      name: 'list',
      desc: '获取列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'pending',
      desc: '获取待处理列表',
      method: 'GET',
      path: '/list?status=0'
    },
    {
      name: 'completed',
      desc: '获取已完成列表',
      method: 'GET',
      path: '/list?status=1'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'GET',
      path: '/delete'
    },
    {
      name: 'view',
      desc: '获取',
      method: 'GET',
      path: '/view'
    },
    {
      name: 'genLotteryItems',
      desc: '随机抽取专家库',
      method: 'GET',
      path: '/genLotteryItems'
    },
    {
      name: 'deleteItems',
      desc: '随机抽取删除抽选项',
      method: 'GET',
      path: '/deleteItems'
    },
    {
      name: 'queryAccordWithCondition',
      desc: '查找符合条件的专家列表',
      method: 'GET',
      path: '/queryAccordWithCondition'
    },
    {
      name: 'queryAccordWithConditionBeforeSave',
      desc: '查找符合条件的专家列表(未保存状态下)',
      method: 'POST',
      path: '/queryAccordWithConditionBeforeSave'
    },
    {
      name: 'save',
      desc: '随机抽取专家库',
      method: 'POST',
      path: '/save'
    },
    {
      name: 'saveItem',
      desc: '保存抽取的专家到本项目中',
      method: 'POST',
      path: '/saveItem'
    },
    {
      name: 'updateSelectedItemsById',
      desc: '改变抽取的人的选择按钮',
      method: 'GET',
      path: '/updateSelectedItemsById'
    },
    {
      name: 'download',
      desc: '下载内容文件',
      method: 'GET',
      path: '/download'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/lottery/index.js